
import AreasContent from "../../Component/Areas/AreasContent";

function Areas() {
  return  <AreasContent />
      
}

export default Areas;
